import { Component, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';

interface ActiveSection {
  name: string;
  isFirst: boolean;
  isLast: boolean;
}

@Component({
  selector: 'mb-transcript-section-selection',
  templateUrl: './transcript-section-selection.component.html',
  styleUrls: ['./transcript-section-selection.component.scss'],
})
export class TranscriptSectionSelectionComponent {
  private _options: string[] = [];

  public currentSection!: ActiveSection;

  @Input()
  set activeSection(v: string) {
    this.currentSection = this.getActiveSection(v);
    this.scrollToSection();
  }

  @ViewChild('selectionInner', { static: false })
  selectionInner!: ElementRef;

  @Input()
  set options(v: string[]) {
    this._options = v || [];
    if (!this.currentSection && this.options.length) {
      this.activeSection = this.options[0];
    }
  }
  get options() {
    return this._options;
  }

  @Output() sectionChanged = new EventEmitter<string>();

  private getActiveSection(section: string) {
    const isFirst = this.options[0] === section;
    const isLast = this.options[this.options.length - 1] === section;
    return {
      name: section,
      isFirst,
      isLast,
    };
  }

  public setActiveSection(section: string) {
    this.sectionChanged.emit(section);
  }

  public scrollToSection() {
    if (!this.currentSection || !this.selectionInner) {
      return;
    }
    const parentWidth = this.selectionInner.nativeElement.parentNode.clientWidth;
    const selectionWidth = this.selectionInner.nativeElement.clientWidth;
    if (this.currentSection.isFirst || parentWidth > selectionWidth) {
      this.selectionInner.nativeElement.style.transform = 'translateX(0px)';
      return;
    }
    const maxOffset = Math.abs(parentWidth - 40 - selectionWidth);
    const el = this.selectionInner.nativeElement.querySelectorAll(`[data-section="${this.currentSection.name}"]`);
    if (!el || !el.length) {
      return;
    }
    let offset = el[0].offsetLeft;
    if (offset > maxOffset) {
      offset = maxOffset;
    }
    this.selectionInner.nativeElement.style.transform = 'translateX(-' + offset + 'px)';
  }

  public scrollSectionBackward() {
    if (!this.currentSection) {
      return;
    }
    const index = (this.options.findIndex((speaker) => speaker === this.currentSection.name) || 0) - 1;
    this.setActiveSection(this.options[index >= 0 ? index : 0]);
  }
  public scrollSectionForward() {
    if (!this.currentSection) {
      return;
    }
    const index = (this.options.findIndex((speaker) => speaker === this.currentSection.name) || 0) + 1;
    this.setActiveSection(this.options[index < this.options.length ? index : 0]);
  }
}
